import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useBillingPortal } from "./hooks";

function ManageBillingButton({ onOpened }) {
  const { loading, openPortal } = useBillingPortal(onOpened);

  return (
    <Button
      content="Manage Billing Information"
      icon="money"
      onClick={openPortal}
      disabled={loading}
      loading={loading}
    />
  );
}

ManageBillingButton.propTypes = { onOpened: PropTypes.func };
ManageBillingButton.defaultProps = { onOpened: () => {} };

export default ManageBillingButton;
